import {Routes} from "@angular/router";
import {ProductEditComponent} from '../product-edit/product-edit.component';
import {ProductViewInfoComponent} from './product-view-info/product-view-info.component';
import {ProductViewPurchasesComponent} from './product-view-purchases/product-view-purchases.component';
import {routerHandler} from "../../../resources/utils/router";

export const ProductViewRoutesData = {
  'redirect': routerHandler.redirect('product'),
  'info': routerHandler.info('product', {component: ProductViewInfoComponent}),
  // 'purchases': routerHandler.purchases('product', {component: ProductViewPurchasesComponent}),
  'edit': routerHandler.edit('product', {component: ProductEditComponent}),
};

export const ProductViewRoutes: Routes = Object.values(ProductViewRoutesData);
